<template>
    <PlanbordGridRow class="weekNumberGridRow">
        <PlanbordGridLeftDataColumns class="weekNumberLeftColumns">
            <PlanbordGridCell>Week</PlanbordGridCell>
            <PlanbordFunctionCell />
            <PlanbordCommentCell />
            <PlanbordStampStartDateCell />
        </PlanbordGridLeftDataColumns>
        <div class="weekNumberGrid">
            <RosterWeek
                v-for="(week, index) in weeks"
                :key="index"
                :week="week"
                :firstVisibleDate="rosterViewSettings.startDate"
            />
        </div>
    </PlanbordGridRow>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridLeftDataColumns from '@/components/Planbord/PlanbordGridLeftDataColumns.vue';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';
    import PlanbordGridRow from '@/components/Planbord/PlanbordGridRow.vue';
    import RosterWeek from '@/components/Planbord/RosterWeek.vue';
    import {RosterViewSettings, Week} from '@/types';
    import Dates from '@cquential/date-utils';

    @Component({
        components: {
            PlanbordGridLeftDataColumns,
            PlanbordGridCell,
            PlanbordStampStartDateCell,
            PlanbordCommentCell,
            PlanbordFunctionCell,
            PlanbordGridRow,
            RosterWeek,
        },
    })
    export default class RosterWeeks extends Vue {
        @Prop({required: true}) public rosterViewSettings!: RosterViewSettings;

        public get weeks(): Week[] {
            const endVisibleDate: Date = Dates.Utils.addDays(this.rosterViewSettings.startDate, this.rosterViewSettings.visibleDays - 1);
            let weekStartDate: Date = Dates.Utils.startOfWeek(this.rosterViewSettings.startDate);
            const result: Week[] = [];
            while (weekStartDate <= endVisibleDate) {
                const thursday: Date = Dates.Utils.addDays(weekStartDate, 3);
                result.push({
                    beginDate: weekStartDate,
                    endDate: Dates.Utils.addDays(weekStartDate, 6),
                    weekNumber: Dates.Utils.isoWeekNumber(thursday),
                });
                weekStartDate = Dates.Utils.addDays(weekStartDate, 7);
            }

            return result;
        }
    }
</script>

<style lang="scss" scoped>
    .weekNumberGridRow {
        grid-auto-flow: column;

        --cell-background-color: var(--main-background-color);
    }

    .weekNumberGrid {
        display: grid;
        grid-column: calc(var(--left-non-day-columns, 0) + 1) / calc(0 - calc(var(--right-non-day-columns, 0) + 1));
        grid-template-columns: subgrid;
        grid-auto-flow: column;
    }
</style>
